import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryLinkIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.2 3.09L20.91 1.8C18.84 -0.270002 15.47 -0.270002 13.41 1.8L9.80001 5.42C9.51001 5.71 9.51001 6.19 9.80001 6.48C10.09 6.77 10.57 6.77 10.86 6.48L14.47 2.86C15.95 1.38 18.37 1.38 19.85 2.86L21.14 4.15C21.86 4.87 22.26 5.82 22.26 6.84C22.26 7.86 21.86 8.81 21.14 9.53L17.27 13.4C15.83 14.84 13.33 14.84 11.89 13.4L10.6 12.11C10.31 11.82 9.83001 11.82 9.54001 12.11C9.25001 12.4 9.25001 12.88 9.54001 13.17L10.83 14.46C11.83 15.46 13.17 16.01 14.58 16.01C15.99 16.01 17.33 15.46 18.33 14.46L22.2 10.59C23.2 9.59 23.75 8.26 23.75 6.84C23.75 5.42 23.2 4.09 22.2 3.09Z"
        fill={color}
      />
      <path
        d="M13.1499 17.52L9.53995 21.14C8.09995 22.58 5.58995 22.58 4.15995 21.14L2.86995 19.85C1.38995 18.37 1.38995 15.95 2.86995 14.47L6.73995 10.6C8.21995 9.12 10.6399 9.12 12.1199 10.6L13.4099 11.89C13.6999 12.18 14.1799 12.18 14.4699 11.89C14.7599 11.6 14.7599 11.12 14.4699 10.83L13.1799 9.54C11.1099 7.47 7.73995 7.47 5.67995 9.54L1.80995 13.41C-0.260054 15.48 -0.260054 18.85 1.80995 20.91L3.09995 22.2C4.09995 23.2 5.42995 23.75 6.84995 23.75C8.26995 23.75 9.59995 23.2 10.5999 22.2L14.2099 18.58C14.4999 18.29 14.4999 17.81 14.2099 17.52C13.9199 17.23 13.4399 17.23 13.1499 17.52Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryLinkIcon.displayName = 'LibraryLinkIcon';
